import { GlDisclosureDropdown, GlDisclosureDropdownItem, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { TYPE_INCIDENT, TYPE_ISSUE } from '~/issues/constants';
import { WORK_ITEM_TYPE_NAME_EPIC, WORK_ITEM_TYPE_NAME_ISSUE } from '~/work_items/constants';
import eventHub from '../event_hub';
const allowedTypes = [
    TYPE_INCIDENT,
    TYPE_ISSUE,
    WORK_ITEM_TYPE_NAME_EPIC,
    WORK_ITEM_TYPE_NAME_ISSUE
];
export default {
    name: 'TaskListItemActions',
    components: {
        GlDisclosureDropdown,
        GlDisclosureDropdownItem
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: [
        'id',
        'issuableType',
        'enabled'
    ],
    computed: {
        showConvertToTaskItem () {
            return allowedTypes.includes(this.issuableType);
        },
        isEnabledTaskListItem () {
            return this.enabled;
        }
    },
    methods: {
        convertToTask () {
            eventHub.$emit('convert-task-list-item', this.eventPayload());
        },
        deleteTaskListItem () {
            eventHub.$emit('delete-task-list-item', this.eventPayload());
        },
        disableTaskListItem () {
            eventHub.$emit('disable-task-list-item', this.eventPayload());
        },
        enableTaskListItem () {
            eventHub.$emit('enable-task-list-item', this.eventPayload());
        },
        eventPayload () {
            return {
                id: this.id,
                sourcepos: this.$el.closest('li').dataset.sourcepos
            };
        },
        // The checklist item is a markdown-rendered <li> outside this component's tree, so toggle
        // the active-row class on it imperatively when the actions menu opens and closes.
        setRowActive (active) {
            this.$el.closest('li')?.classList.toggle('task-list-item-active', active);
        }
    }
};
